import { Box, CircularProgress, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import SEO from '../atoms/SEO';
import Footer from '../molecules/Footer';
import FooterWhatsapp from '../molecules/FooterWhatsapp';
import Header from '../organisms/Header';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
});

const Main = ({
  page, children, header, purpleFriday, removeFooter,
}) => {
  const classes = useStyles();
  const [isFooterWidgetOpen, setIsFooterWidgetOpen] = useState(true);

  const useStyless = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: '#0093F5',
      backgroundColor: '#FFF',
      width: '100%',
      height: '100vh',
      position: 'absolute',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
    },
  }));

  const FullScreenLoading = ({ open = true }) => {
    const classess = useStyless();

    return (
      <>
        {open && (
        <div className={classess.backdrop}>
          <CircularProgress color="inherit" />
        </div>
        )}
      </>
    );
  };

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => { setIsLoading(false); }, 1000);
  }, []);
  return (
    <>
      <FullScreenLoading open={isLoading} />

      <SEO page={page} />
      {!isLoading && (
        <>
          {/*
            header (prop) em vez do <Header /> fixo: paginas satelites como a
            /servicos-paralegais passam o proprio cabecalho. O default e o
            Header do site, entao nenhuma pagina existente muda.
          */}
          {!purpleFriday && header}
          <Box className={classes.root}>{children}</Box>
          {!removeFooter && <Footer isFooterWidgetOpen={isFooterWidgetOpen} />}
          <FooterWhatsapp
            isFooterWidgetOpen={isFooterWidgetOpen}
            setIsFooterWidgetOpen={setIsFooterWidgetOpen}
          />
        </>
      )}

    </>
  );
};

Main.defaultProps = {
  children: <></>,
  // Paginas satelites (ex.: servicos-paralegais, aberta em nova guia a partir do
  // menu principal) passam seu proprio header aqui, sem menu, ja que quem chega
  // la nao precisa navegar pelo resto do site nessa aba.
  header: <Header />,
  purpleFriday: false,
  removeFooter: false,
};

Main.propTypes = {
  page: PropTypes.string.isRequired,
  children: PropTypes.element,
  header: PropTypes.node,
  purpleFriday: PropTypes.bool,
  removeFooter: PropTypes.bool,
};

export default Main;
